import type { TokenToInjectable } from '@/di/di.types'

import useDi from '../useDi'

export default function useService<T extends keyof TokenToInjectable>(
  token: T
) {
  const { container } = useDi()
  return { service: container.get(token) }
}
